// src/components/tutorials/JS_Math_Reference.jsx
import React from "react";
import "../../../AllComponentCSS.css";

export default function JS_Math_Reference() {
  const mathReference = [
    { name: "E", description: "Euler's number, approximately 2.718" },
    { name: "LN2", description: "Natural logarithm of 2, approximately 0.693" },
    {
      name: "LN10",
      description: "Natural logarithm of 10, approximately 2.302",
    },
    {
      name: "LOG2E",
      description: "Base-2 logarithm of E, approximately 1.443",
    },
    {
      name: "LOG10E",
      description: "Base-10 logarithm of E, approximately 0.434",
    },
    {
      name: "PI",
      description:
        "Ratio of the circumference of a circle to its diameter, approximately 3.14159",
    },
    { name: "SQRT1_2", description: "Square root of 1/2, approximately 0.707" },
    { name: "SQRT2", description: "Square root of 2, approximately 1.414" },
    {
      name: "abs(x)",
      description: "Returns the absolute (positive) value of x",
    },
    { name: "acos(x)", description: "Returns the arccosine (in radians) of x" },
    { name: "acosh(x)", description: "Returns the hyperbolic arccosine of x" },
    { name: "asin(x)", description: "Returns the arcsine (in radians) of x" },
    { name: "asinh(x)", description: "Returns the hyperbolic arcsine of x" },
    {
      name: "atan(x)",
      description: "Returns the arctangent (in radians) of x",
    },
    {
      name: "atan2(y, x)",
      description: "Returns the arctangent of the quotient of its arguments",
    },
    { name: "atanh(x)", description: "Returns the hyperbolic arctangent of x" },
    { name: "cbrt(x)", description: "Returns the cube root of x" },
    {
      name: "ceil(x)",
      description: "Returns x rounded up to its nearest integer",
    },
    {
      name: "clz32(x)",
      description: "Returns the number of leading zeros in a 32-bit integer",
    },
    { name: "cos(x)", description: "Returns the cosine of x (x in radians)" },
    { name: "cosh(x)", description: "Returns the hyperbolic cosine of x" },
    { name: "exp(x)", description: "Returns E raised to the power of x" },
    { name: "expm1(x)", description: "Returns E^x - 1" },
    {
      name: "floor(x)",
      description: "Returns x rounded down to its nearest integer",
    },
    {
      name: "fround(x)",
      description:
        "Returns the nearest 32-bit single precision float representation of x",
    },
    {
      name: "hypot(x, y, ...)",
      description:
        "Returns the square root of the sum of squares of its arguments",
    },
    {
      name: "imul(a, b)",
      description: "Performs 32-bit integer multiplication",
    },
    {
      name: "log(x)",
      description: "Returns the natural logarithm (base E) of x",
    },
    { name: "log10(x)", description: "Returns the base-10 logarithm of x" },
    { name: "log1p(x)", description: "Returns the natural log of (1 + x)" },
    { name: "log2(x)", description: "Returns the base-2 logarithm of x" },
    {
      name: "max(a, b, ...)",
      description: "Returns the number with the highest value",
    },
    {
      name: "min(a, b, ...)",
      description: "Returns the number with the lowest value",
    },
    {
      name: "pow(x, y)",
      description: "Returns the value of x to the power of y",
    },
    {
      name: "random()",
      description: "Returns a random number between 0 and 1",
    },
    {
      name: "round(x)",
      description: "Returns x rounded to its nearest integer",
    },
    { name: "sign(x)", description: "Returns the sign of x (1, -1, or 0)" },
    { name: "sin(x)", description: "Returns the sine of x (x in radians)" },
    { name: "sinh(x)", description: "Returns the hyperbolic sine of x" },
    { name: "sqrt(x)", description: "Returns the square root of x" },
    { name: "tan(x)", description: "Returns the tangent of x (x in radians)" },
    { name: "tanh(x)", description: "Returns the hyperbolic tangent of x" },
    {
      name: "trunc(x)",
      description: "Returns the integer part of x (removes decimals)",
    },
  ];

  return (
    <div className="tutorial-container" style={{ padding: "2rem" }}>
      <h1 className="tutorial-title" style={{ textAlign: "center" }}>
        🧮 JavaScript Math Reference
      </h1>
      <p style={{ textAlign: "center", color: "#555", marginBottom: "1rem" }}>
        All Math constants and methods in JavaScript (Updated 2025)
      </p>

      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          overflow: "hidden",
          maxWidth: "900px",
          margin: "0 auto",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr
              style={{
                background: "linear-gradient(90deg, #6366f1, #60a5fa)",
                color: "white",
                textAlign: "left",
              }}
            >
              <th style={{ padding: "14px 20px", fontWeight: "600" }}>Name</th>
              <th style={{ padding: "14px 20px", fontWeight: "600" }}>
                Description
              </th>
            </tr>
          </thead>
          <tbody>
            {mathReference.map((item, index) => (
              <tr
                key={item.name}
                style={{
                  backgroundColor: index % 2 === 0 ? "#f8fafc" : "#eef2ff",
                  transition: "background 0.3s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#dbeafe")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor =
                    index % 2 === 0 ? "#f8fafc" : "#eef2ff")
                }
              >
                <td
                  style={{
                    padding: "14px 20px",
                    borderBottom: "1px solid #e2e8f0",
                    fontWeight: "500",
                  }}
                >
                  {item.name}
                </td>
                <td
                  style={{
                    padding: "14px 20px",
                    borderBottom: "1px solid #e2e8f0",
                  }}
                >
                  {item.description}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        style={{
          background: "linear-gradient(135deg, #c7d2fe, #a5b4fc)",
          padding: "1rem 2rem",
          borderRadius: "12px",
          marginTop: "2rem",
          maxWidth: "900px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <h2 style={{ color: "#1e3a8a" }}>🚀 Quick Notes</h2>
        <ul style={{ lineHeight: "1.8" }}>
          <li>
            All Math properties are static — call them as{" "}
            <code>Math.property</code>.
          </li>
          <li>
            Common methods: <code>Math.floor()</code>, <code>Math.round()</code>
            , <code>Math.random()</code>,<code>Math.pow()</code>.
          </li>
          <li>
            Use <code>Math.trunc()</code> to remove decimals without rounding.
          </li>
          <li>
            <code>Math.random()</code> can be scaled:{" "}
            <code>Math.floor(Math.random() * max)</code>.
          </li>
          <li>Use this table as your complete Math reference guide.</li>
        </ul>
      </div>
    </div>
  );
}
